<template>
</template>>
<script>
import md5 from 'js-md5'
export default {
  // 调用接口用
  userid: '',
  username :'',
  fieldSettingTitle:'拖拽字段到此处',
  fieldSettingInputTitle:'请输入内容',
  
  genSign(params,userid) {
    const ordered = {};
    Object.keys(params).sort().forEach(function(key) {
      ordered[key] = params[key];
    });
//console.log(ordered);
    let myString = '';
    for(let key in ordered) {
      if(myString == '') {
        myString = key+'='+ordered[key];
      } else {
        myString = myString + '&'+key+'='+ordered[key];
      }
    }// myString
    myString  = myString  + '_' + userid+'_myADP79#';
    //myString=encodeURIComponent(myString);
    //console.log(myString);
    let sign = md5(myString);
    return sign;
  },
  genSignEx(qstring,userid) {
    let index = qstring.indexOf('?');
    let splitString = qstring;
    if(index >= 0) {
      splitString = qstring.substr(index+1);
    }
    let splitStringArr = splitString.split('&');
    let params = {};
    let one = '';
    for(let key in splitStringArr) {
      one = splitStringArr[key];
      let oneArr = one.split('=');
      if(oneArr.length >= 2) {
        params[oneArr[0]] = oneArr[1];
      }
    }
    let sign = this.genSign(params,userid);
    return sign;
  },
  getCurTimes() {
    let myDate = new Date();
    let times = myDate.getTime();
    let rm=Math.round(Math.random()*10);
    return times+""+rm;
  }
}
</script>